<template>
  <div class="show_order">
    <div class="order-wrap">
      <div class="top_steps">
        <span class="click_point" @click="goToIndex">{{
          TLang("演出首页", "my")
        }}</span>
        <span class="top_arrow_icon">
          <img :src="staticAssets.ImgObj.arrow_right" alt />
        </span>
        <span class="product_name" v-if="table_source.projectName">{{
          table_source.projectName
        }}</span>
      </div>
      <div class="ticket_info">
        <div class="confirm_title ticket_info_title">
          {{ TLang("取票信息", "my") }}
        </div>
        <!-- 取票方式 -->
        <ticket-type
          :table_source="table_source"
          :kuaidi_type="kuaidi_flag"
          ref="ticketType"
        />
        <div class="border_br"></div>
        <!-- 收货地址 -->
        <div
          class="ticket_info_user ticket_info_address"
          v-if="table_source.defDeliveryType != null && kuaidi_flag"
        >
          <ticket-address
            :tableTicket_data="table_source"
            :addressSource="cardTableAddress"
            :real_name_type="real_name_type"
            :lastOrderAddress="lastAddressId"
            :checked_flag="name_checked_flag"
            :address_more="cardTableAddress_flag"
            :kuaidi_type="kuaidi_flag"
            :tips_flag="tips_address_model"
            @changeExpress="getChangeExpress"
            @formData="checkFormCard"
            @delConfirm="delAddressInfo"
            @resetTips="tips_address_model = false"
            ref="ticketAddress"
          />
        </div>
        <!-- 取票人 -->
        <div class="ticket_info_user" v-if="!kuaidi_flag">
          <ticket-user
            :cardFormData="cardForm_Data"
            :real_name_type="real_name_type"
            ref="ticketUser"
            @formData="checkFromData"
          />
        </div>
        <!-- 自取地址 -->
        <div
          class="ticket_info_user ticket_info_location"
          v-if="
            table_source.defDeliveryType != null &&
            (table_source.defDeliveryType == 4 ||
              table_source.defDeliveryType == 3)
          "
        >
          <ticket-location
            :locationSource="ticketLocationData"
            :locationAll="all_location_address"
            :detail_flag="2"
            :type_ticket="
              table_source.defDeliveryType == 3
                ? 1
                : table_source.defDeliveryType == 4
                ? 2
                : 0
            "
            ref="ticketLocation"
          />
        </div>
        <!-- 观演人 -->
        <div class="ticket_info_user" v-if="real_name_type == 2">
          <ticket-viewer
            :table_source="table_source"
            :viewer_source="cardTableData"
            :kuaidi_type="kuaidi_flag"
            :tips_flag="tips_model"
            @resetTips="tips_model = false"
            @delConfirm="delUserInfo"
            ref="ticketViewer"
          />
        </div>
      </div>
      <div class="order_info">
        <div class="confirm_title order_info_title">
          {{ TLang("订单信息", "my") }}
        </div>
        <order-table
          :orderData="table_source"
          :advanceFlag="table_source.projectType"
          :orderPay="orderPay_flag"
          :evFlag="ev_flag"
        />
      </div>
      <div class="total_info">
        <div class="total_info_right">
          <div class="total_info_right_title" v-if="mul_welfarePrice > 0">
            <span class="right_title_text">{{ TLang("优惠福豆", "my") }}</span>
            <span
              class="total_info_right_pay"
              style="
                color: rgba(17, 17, 17, 1);
                font-size: 14px;
                font-weight: normal;
                width: 99px;
              "
            >
              -{{ publicMethod.formatPrice(mul_welfarePrice)
              }}{{ publicMethod.formatPrice(mul_welfarePrice, "fixed") }}
            </span>
          </div>
          <div class="total_info_right_title" v-if="kuaidi_flag">
            <span class="right_title_text"
              >{{ TLang("运费", "my") }}({{
                JSON.stringify(unionInfo) != "{}" && unionInfo.name
                  ? unionInfo.name
                  : TLang("福豆", "card")
              }}):</span
            >
            <span
              class="total_info_right_pay"
              style="
                color: rgba(17, 17, 17, 1);
                font-size: 14px;
                font-weight: normal;
                width: 99px;
              "
            >
              {{
                publicMethod.formatPrice(
                  unionInfo.scale
                    ? unionInfo.scale * express_total_price
                    : express_total_price
                )
              }}{{
                publicMethod.formatPrice(
                  unionInfo.scale
                    ? unionInfo.scale * express_total_price
                    : express_total_price,
                  "fixed"
                )
              }}
            </span>
          </div>
          <div class="total_info_right_title">
            <span class="right_title_text">{{ TLang("需支付", "my") }}</span>
            <span class="new_total_style">
              <img
                :src="
                  unionInfo.icon
                    ? unionInfo.icon
                    : staticAssets.ImgObj.fudou_icon
                "
                alt
              />
              <span class="total_info_right_pay">
                {{
                  unionInfo.scale
                    ? (
                        confirm_total_price +
                        unionInfo.scale * express_total_price
                      ).toFixed(2)
                    : (confirm_total_price + express_total_price).toFixed(2)
                }}
              </span>
            </span>
          </div>
          <div v-if="mallGary" class="serviceFeeTip">
            本单可能收取平台服务费，以支付页为准
          </div>
          <div class="total_info_right_btn">
            <a
              href="javascript:;"
              :class="{ not_allowed_btn: confirm_btn_flag }"
              @click="submitConfirm"
              >{{ TLang("提交订单", "list") }}</a
            >
          </div>
          <p class="total_info_right_tips">
            {{ TLang("尊敬的用户", "my") }}
          </p>
        </div>
      </div>
    </div>
    <el-dialog
      title="信息核实"
      :visible.sync="dialogFormVisible"
      width="528px"
      class="confirm_dialog_body"
      @close="getCardClose"
      center
      :close-on-click-modal="false_flag"
    >
      <div slot="title" class="header-title">
        <span class="title-name">{{ TLang("信息核实", "my") }}</span>
        <span class="title-del" @click="getCardClose">
          <img :src="staticAssets.ImgObj.pop_del_icon" alt />
        </span>
      </div>
      <div class="confirm_user_list" v-if="real_name_type != 2 && !kuaidi_flag">
        {{ TLang("为了不影响您的观演", "my") }}
      </div>
      <div class="confirm_user_list" v-if="!kuaidi_flag && real_name_type == 2">
        {{ TLang("为了不影响您的观演请核实", "my") }}
      </div>
      <div class="confirm_user_list" v-if="kuaidi_flag && real_name_type != 2">
        {{ TLang("为了不影响您的观演不支持退换", "my") }}
      </div>
      <div class="confirm_user_list" v-if="kuaidi_flag && real_name_type == 2">
        {{ TLang("为了不影响您的观演观演人信息", "my") }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="dialog_btn dialog_confirm"
          type="primary"
          @click="confirmUserBtn"
          >{{ TLang("确认提交", "my") }}</el-button
        >
        <el-button
          class="dialog_btn dialog_cancel cancel-btn"
          @click="dialogFormVisible = false"
          >{{ TLang("再看看", "my") }}</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="confirmVisible"
      class="confirm_dialog"
      width="420px"
      center
      v-if="
        confirm_dialog_error
          ? staticAssets.ImgObj.confirm_error_img
          : staticAssets.ImgObj.del_success
      "
      v-cloak
    >
      <div slot="title" class="header-title">
        <span class="title-del title_confirm_del" @click="getDelClose">
          <img :src="staticAssets.ImgObj.pop_del_icon" alt />
        </span>
      </div>
      <div class="confirm_top">
        <img
          :src="
            confirm_dialog_error
              ? staticAssets.ImgObj.confirm_error_img
              : staticAssets.ImgObj.del_success
          "
          v-if="
            (confirm_dialog_error && staticAssets.ImgObj.confirm_error_img) ||
            (!confirm_dialog_error && staticAssets.ImgObj.del_success)
          "
          alt
        />
        <div
          class="confirm_text"
          :class="{ confirm_text_error: confirm_dialog_error }"
        >
          {{
            confirm_dialog_error
              ? TLang("抱歉您的订单提交失败", "home")
              : address_del
              ? TLang("您要删除该收货地址吗", "address")
              : TLang("您要删除该取票人信息吗", "address")
          }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="!confirm_dialog_error">
        <el-button
          class="dialog_btn dialog_confirm"
          type="primary"
          style="font-weight: bold"
          @click="confirmDeleteUser"
          >{{ TLang("删除", "home") }}</el-button
        >
        <el-button
          class="dialog_btn dialog_cancel"
          @click="confirmVisible = false"
          >{{ TLang("不删除", "list") }}</el-button
        >
      </div>
      <div
        slot="footer"
        class="dialog-footer"
        :class="{ error_footer: confirm_dialog_error }"
        v-if="confirm_dialog_error"
      >
        <el-button
          class="dialog_btn dialog_confirm"
          type="primary"
          @click="backToDetail"
          >{{ TLang("返回演出详情", "my") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { unionFlag } from "@/utils";
import { mapState } from "vuex";
export default {
  name: "OrderConfirm",
  data() {
    return {
      address_newId: null,
      cardForm_Data: {
        consigneeName: "",
        consigneePhone: "",
        ownerIdCardNo: "",
        verificationCode: "",
      },
      lastAddressId: null,
      cardTableAddress_flag: false, //是否展示更多地址
      userId: 1,
      kuaidi_flag: false,
      defDeliveryType_flag: null,
      select_click_flag: false, //是否点击下拉更多地址
      false_flag: false, //遮罩层关闭
      name_checked_flag: 0, //当前选中用户名
      confirm_dialog_error: false, //confirm条件下提交失败
      orderPay_flag: false, //判定是否是确认订单的订单详情
      cardTableData: [],
      ticketLocationData: [],
      all_location_address: [],
      cardTableAddress: [],
      real_name_type: 0, //实名类型0-非实名认证、1-一单一证、2-一票一证
      ticket_type: 0, //普通票、套票类型0普通1套票
      mul_welfarePrice: 0, //优惠的价格
      tips_model: false,
      tips_address_model: false,
      dialogFormVisible: false, //添加用户信息dialog开关
      confirmVisible: false, //confirm的dialog开关
      operate_index: null, //删除项的index,
      address_del: false, //是否删除收货地址
      confirm_total_price: null, //订单总价
      express_total_price: null, //运费总价
      currentGoodsId: null, //保存当前商品id
      cardForm_ticket: this.staticAssets.cardForm_ticket,
      cardForm_kuaidi: {
        ownerIdCardNo: "",
      },
      table_source: "", //order table的数据
      confirm_btn_flag: false,
      queryData: {},
      ev_flag: null,
      mallGary: false,
    };
  },
  beforeCreate() {
    //开启加载动画
    //this.publicMethod.openLoading();
  },
  created() {
    this.queryData = this.$route.query; //接收详情传参
    this.getConfirmData(); //获取确认订单(从详情页面)
    // 获取灰度状态
    this.apis.showOrder.getMallGray().then((res) => {
      if (!res.code) {
        this.mallGary = res.body;
      }
    });
    this.apis.showOrder
      .getLoginStatus({
        platform: 0,
        unionFlag: unionFlag() ? 1 : 0,
        union: unionFlag() ? unionFlag() : 0,
      })
      .then((res) => {
        if (res.loginFlag === 0) {
          window.df_sdk_common.location.href =
            res.loginUrl +
            "&returnUrl=" +
            encodeURIComponent(window.location.href);
        }
      });
    const { VUE_APP_FLAG } = process.env;
    if (VUE_APP_FLAG === "pro" || VUE_APP_FLAG === "stage") {
      this.ev_flag = 1;
    } else {
      this.ev_flag = 2;
    }
  },
  // 移除滚动事件
  destroyed() {
    //window.removeEventListener("scroll", this.handleScroll, true);
  },
  components: {
    orderTable: () => import("./OrderInfo.vue"), //订单信息table
    ticketUser: () => import("./TicketUser.vue"), //取票人
    ticketAddress: () => import("./TicketAddress.vue"), //收货地址
    ticketLocation: () => import("./TicketLocation.vue"), //上门自取地址
    ticketViewer: () => import("./TicketViewer.vue"), // 观演人
    ticketType: () => import("./TicketType.vue"), // 票品类型
  },
  computed: {
    ...mapState({
      unionInfo: "unionInfo",
    }),
  },
  methods: {
    //去逛逛 返回首页
    goToIndex() {
      this.$router.push({
        path: "/home",
        query: {},
      });
    },
    // 删除收货地址
    getDeleteAddress(delId) {
      const orderData = {
        userAddressId: delId,
      };
      this.apis.showOrder.getDelAddress(orderData).then((data) => {
        if (!data.code) {
          // 更新收货地址信息、列表
          this.publicMethod.getThrowInfo(
            TLang("删除地址成功！", "my"),
            "success"
          );
          this.$refs.ticketAddress.cardTableAddress.splice(
            this.operate_index,
            1
          );
          this.$refs.ticketAddress.getUserAddressAll(
            this.lastAddressId,
            "del_flag"
          );
        } else {
          this.publicMethod.getThrowInfo(data.msg, "error");
        }
      });
    },
    //获取订单确认信息
    getConfirmData() {
      //转换订单详情数据格式
      let sourceConfirmData = JSON.parse(
        window.sessionStorage.getItem("table_source")
      );
      let goodsItem = {
        priceName: {},
        ticketPrice: [],
        quantity: [],
        seatInfo: [], //目前pc订单确认页全是无座
        seatInfoObj: { 0: [] },
        seatNum: null,
        priceNameTitle: sourceConfirmData.priceName,
      };
      goodsItem.seatNum = 1; //无座条件下  默认 档位为1个
      goodsItem.ticketPrice.push(sourceConfirmData.ticketPrice);
      goodsItem.quantity.push(sourceConfirmData.quantity);
      this.table_source = Object.assign({}, sourceConfirmData, goodsItem);
      //兼容多票档
      goodsItem.priceName[`level0`] = [];
      //标记是否是套票普通票 0普通票1套票
      if (this.table_source.priceType != 0) {
        this.table_source.subPrices.forEach((i) => {
          goodsItem.priceName[`level0`].push(
            sourceConfirmData.priceName + "—" + i.ticketPrice
          );
          goodsItem.seatInfo.push(TLang("无座", "my"));
          goodsItem.seatInfoObj[0].push(TLang("无座", "my"));
        });
        this.ticket_type = this.table_source.priceType;
        this.mapTicketMulitiple(sourceConfirmData);
      } else {
        goodsItem.priceName[`level0`].push(sourceConfirmData.priceName);
        goodsItem.seatInfo.push(TLang("无座", "my"));
        goodsItem.seatInfoObj[0].push(TLang("无座", "my"));
        this.ticket_type = 0;
      }
      //defDeliveryType类型判定
      if (sourceConfirmData.defDeliveryType != null) {
        switch (sourceConfirmData.defDeliveryType) {
          case 2:
            this.getKuaiDiAddress(); //defDeliveryType ==2 快递
            break;
          case 3:
            this.getMachineLocation(); //defDeliveryType ==3 自助机取票
            break;
          case 4:
            this.getSelfTake(sourceConfirmData); //defDeliveryType ==4 门店自取
            break;
          default:
            this.getDefault(); //defDeliveryType ==other
            break;
        }
        //标记是否是纸质票
        sourceConfirmData.defDeliveryType == 2
          ? (this.kuaidi_flag = true)
          : (this.kuaidi_flag = false);
      }
      this.defDeliveryType_flag = sourceConfirmData.defDeliveryType;
      //标记是否是实名类型
      this.real_name_type = sourceConfirmData.realNameRegType;
      this.confirm_total_price = this.unionInfo.scale
        ? this.unionInfo.scale * Number(this.table_source.totalPrice)
        : this.table_source.totalPrice;
      this.currentGoodsId = this.table_source.goodsId; //赋值当前商品id
    },
    getDefault() {
      //console.log("defDeliveryType不在判定范围");
    },
    //当票品类型为快递
    getKuaiDiAddress() {
      this.apis.showOrder.getLastAddress().then((data) => {
        if (!data.code) {
          if (data.body == null) {
            this.getUserAddressAll();
          } else {
            this.lastAddressId = data.body;
            this.$nextTick(() => {
              this.getUserAddressAll(data.body);
            });
          }
        }
      });
    },
    //当票品类型为自助机
    getMachineLocation() {
      let machine_params = {
        supplierId: this.table_source.supplierId, //供应商id， 大麦1
        goodsId: this.table_source.goodsId, //155027
        dfflRondaId: this.table_source.performId,
        supplierFetchTicketWayId: this.table_source.supplierFetchTicketWayId,
      };
      this.apis.showOrder.getMachineSource(machine_params).then((data) => {
        if (!data.code) {
          this.all_location_address = data.body;
          if (data.body.length > 3) {
            this.ticketLocationData = data.body.slice(0, 3);
          } else {
            this.ticketLocationData = data.body;
          }
        }
      });
    },
    //当票品类型为上门自取
    getSelfTake(source_data) {
      source_data.pickupAddressList.forEach((i) => {
        this.all_location_address.push(JSON.parse(i));
      });
      this.ticketLocationData.push(this.all_location_address[0]);
    },
    //当票品为套票时遍历套票信息
    mapTicketMulitiple(sourceData) {
      let mul_totalPrice = 0;
      let mul_ticket = sourceData.subPrices;
      mul_ticket = !mul_ticket || mul_ticket.length < 1 ? [] : mul_ticket;
      if (mul_ticket.length > 0) {
        mul_ticket.forEach((i) => {
          mul_totalPrice += i.count * i.ticketPrice;
        });
        this.mul_welfarePrice =
          ((mul_totalPrice * 1000 - sourceData.ticketPrice * 1000) / 1000) *
          sourceData.quantity;
      }
    },
    //关闭新增用户dialog回调
    getCardClose() {
      //新增编辑重置form表单、确认不重置表单
      this.dialogFormVisible = false;
    },
    //删除的关闭
    getDelClose() {
      this.confirmVisible = false;
    },

    //删除收货地址
    delAddressInfo(dIndex) {
      this.confirmVisible = true;
      this.address_del = true;
      this.operate_index = dIndex.dIndex; //赋值当前删除下标
      this.select_click_flag = dIndex.select__flag;
    },
    //获取所有收货地址
    getUserAddressAll(m_flag) {
      const loading = this.$loading({
        lock: true,
      });
      // 获取商品数据
      const orderData = {
        // userId: this.userId
        //  userAddressId:null
      };
      this.apis.showOrder.getAddressAll(orderData).then((data) => {
        if (!data.code) {
          // 赋值确认订单信息
          if (data.body.length < 1 || !data.body) {
            this.cardTableAddress = [];
          } else {
            //是否展示更多地址
            this.cardTableAddress_flag = data.body.length > 1 ? true : false;
            //判断是否存在新增、最后一次下单
            if (!!m_flag && !!this.lastAddressId) {
              let exchangArray = [...data.body];
              //不是新增情况下获取全部地址
              if (!this.address_newId) {
                this.address_newId = null;
                data.body.forEach((i, v) => {
                  if (i.id == this.lastAddressId) {
                    let lastAddress = i;
                    exchangArray.splice(v, 1);
                    exchangArray.unshift(lastAddress);
                  }
                });
              } else {
                data.body.forEach((i, v) => {
                  if (i.id == this.address_newId) {
                    let lastAddress = i;
                    exchangArray.splice(v, 1);
                    exchangArray.unshift(lastAddress);
                  }
                });
              }
              //判断是否是展示所有地址
              if (this.select_click_flag) {
                this.cardTableAddress = exchangArray;
              } else {
                this.name_checked_flag != 0
                  ? (this.cardTableAddress = [
                      exchangArray[this.name_checked_flag - 1],
                    ])
                  : (this.cardTableAddress = [...exchangArray.slice(0, 1)]);
              }
            } else {
              //判断是否是展示所有地址
              this.select_click_flag
                ? (this.cardTableAddress = data.body)
                : (this.cardTableAddress = [...data.body.slice(0, 1)]);
            }
            m_flag != "more" ? (this.name_checked_flag = 0) : "";
            //关闭更多地址不调运费
            m_flag != "more" ? this.getCalculateExpressFee() : "";
          }
          loading.close();
        } else {
          loading.close();
          this.publicMethod.getThrowInfo(data.msg, "error");
        }
      });
    },
    //获取运费
    getCalculateExpressFee() {
      let userIndexData =
        this.name_checked_flag == 0 || this.cardTableAddress.length == 1
          ? this.cardTableAddress[0]
          : this.cardTableAddress[this.name_checked_flag - 1];

      let expressData = {
        goodsId: this.table_source.goodsId,
        city: userIndexData ? userIndexData.cityId : 145, //重置默认city
        cityName: userIndexData ? userIndexData.cityName : "上海",
        fetchticketId: this.table_source.fetchticketId,
        districtId: userIndexData ? userIndexData.regionId : '',
        districtName: userIndexData ? userIndexData.regionName : '',
        supplierId: this.table_source.supplierId,
      };
      this.apis.showOrder.getCalculateExpressFee(expressData).then((data) => {
        if (!data.code) {
          this.express_total_price = data.body;
        } else {
          this.express_total_price = null;
          this.publicMethod.getThrowInfo(data.msg, "error");
        }
      });
    },
    getChangeExpress(val) {
      this.express_total_price = val;
    },
    //删除取票人信息
    delUserInfo(dIndex) {
      this.confirmVisible = true;
      this.operate_index = dIndex; //赋值当前删除下标
      this.address_del = false;
    },
    //确认删除取票人信息
    confirmDeleteUser() {
      if (this.address_del) {
        //是否是收货地址的确认删除
        this.getDeleteAddress(
          this.$refs.ticketAddress.cardTableAddress[this.operate_index].id
        );
      } else {
        //当是组合票时 删除子组件中的暂存值 ticket_type!=0为套票
        if (this.ticket_type != 0) {
          this.$refs.ticketViewer.mulDeleteItem(
            this.$refs.ticketViewer.cardTableData[this.operate_index]
              .subPriceId,
            this.operate_index
          );
        }
        this.$refs.ticketViewer.cardTableData.splice(this.operate_index, 1);
      }

      this.confirmVisible = false;
    },
    //确认取票人信息
    confirmUserBtn() {
      console.log(this.table_source, '==');
      // 判断是否是可配送地址
      if (this.express_total_price == null && this.kuaidi_flag) {
        this.publicMethod.getThrowInfo(
          TLang("请更改收货地址信息", "my"),
          "error"
        );
        return false;
      }
      this.dialogFormVisible = false;
      this.confirm_btn_flag = true; //是否点击确认订单的标记
      let createdSource = {};
      //let baseOrigin = window.location.origin;
      let tableData = {
        platform: 0,
        supplierId: this.table_source.supplierId || 1,
        goodsId: this.table_source.goodsId,
        categoryId: this.table_source.categoryId,
        performId: this.table_source.performId,
        cityId: this.queryData.city,
        issueTicketType: this.table_source.defIssueTicketType,
        quantity: this.table_source.quantity[0],
        deliveryType: this.table_source.defDeliveryType,
        issueEnterModes: this.table_source.defIssueEnterModes,
        returnUrl: "",
        realNameRegType: this.table_source.realNameRegType,
        fetchticketId: this.table_source.fetchticketId
      };
      //consigneeInfo(收货人信息) holderList （观演人信息）
      let userIndexData = null;
      if (this.table_source.defDeliveryType != null && this.kuaidi_flag) {
        userIndexData =
          (this.$refs.ticketAddress &&
            this.$refs.ticketAddress.name_checked_flag == 0) ||
          (this.$refs.ticketAddress &&
            this.$refs.ticketAddress.cardTableAddress.length == 1)
            ? this.$refs.ticketAddress.cardTableAddress[0]
            : this.$refs.ticketAddress.cardTableAddress[
                this.$refs.ticketAddress.name_checked_flag - 1
              ];
      }
      let orderUser = {
        consigneeInfo:
          this.table_source.defDeliveryType != null && this.kuaidi_flag
            ? Object.assign({}, userIndexData, {
                consigneeIdCard: this.cardForm_kuaidi.ownerIdCardNo,
                consigneeName: userIndexData.consignee,
                consigneePhone: userIndexData.mobile,
                districtId: userIndexData.regionId,
                province: userIndexData.provinceName,
                city: userIndexData.cityName,
                district: userIndexData.regionName,
                street: userIndexData.streetName,
                addressId: userIndexData.id,
                address:
                  userIndexData.provinceName +
                  userIndexData.cityName +
                  userIndexData.regionName +
                  userIndexData.streetName +
                  userIndexData.address,
                expressFee:
                  this.express_total_price.toString().indexOf(".") > 0
                    ? this.express_total_price
                    : this.express_total_price + ".00",
              })
            : {
                consigneeName: this.cardForm_ticket.consigneeName,
                consigneePhone: this.cardForm_ticket.consigneePhone,
                consigneeIdCard:
                  this.real_name_type != 2 && this.real_name_type != 0
                    ? this.cardForm_ticket.ownerIdCardNo
                    : "",
              },
        holderList:
          this.real_name_type == 2 ? this.$refs.ticketViewer.cardTableData : [],
      };
      //当非一票一证时
      if (this.real_name_type != 2) {
        //套票情况
        if (this.ticket_type != 0) {
          this.table_source.subPrices.forEach((j) => {
            for (let i = 0; i < j.count * this.table_source.quantity; i++) {
              orderUser.holderList.push({
                priceId: this.table_source.priceId,
                subPriceId: j.id,
              });
            }
          });
        } else {
          //非套票情况
          for (let i = 0; i < this.table_source.quantity; i++) {
            orderUser.holderList.push({
              priceId: this.table_source.priceId,
            });
          }
        }
      }
      createdSource = Object.assign({}, tableData, orderUser);
      this.apis.showOrder.getCreatedOrder(createdSource).then((res) => {
        if (res && !res.code) {
          window.df_sdk_common.location.href = res.body.payUrl;
        } else if (res && res.code && res.code === 101002) {
          //let baseOrigin = window.location.origin;
          this.$message({
            showClose: true,
            message: this.TLang("请重新登录", "home"),
            type: "error",
            onClose: () => {
              // window.location.href = `${baseOrigin}/user/login?city=${
              //   this.queryData.city
              // }&return_url=${encodeURIComponent(
              //   window.location.href.slice(0, window.location.href.indexOf("?"))
              // )}`;
              this.apis.showOrder
                .getLoginStatus({
                  platform: 0,
                  unionFlag: unionFlag() ? 1 : 0,
                  union: unionFlag() ? unionFlag() : 0,
                })
                .then((res) => {
                  if (res.loginFlag === 0) {
                    window.df_sdk_common.location.href =
                      res.loginUrl +
                      "&returnUrl=" +
                      encodeURIComponent(window.location.href);
                  }
                });
            },
          });
        } else {
          //不成功条件下  按钮可点
          this.confirm_btn_flag = false;
        }
      });
    },
    //提交确认订单
    submitConfirm() {
      //判断是否是包含取票人的验证码校验
      if (!this.kuaidi_flag) {
        this.$refs.ticketUser.getCheckForm();
      } else {
        if (this.real_name_type == 1) {
          this.$refs.ticketAddress.getCheckForm();
        } else {
          this.checkTicketInfo();
        }
      }
    },
    //提交订单信息复查
    checkTicketInfo() {
      if (this.confirm_btn_flag) {
        //判断是否二次点击提交订单
        return false;
      }
      //判断快递取票时  地址是否为空
      if (
        this.$refs.ticketAddress &&
        this.$refs.ticketAddress.cardTableAddress.length < 1 &&
        this.defDeliveryType_flag == 2
      ) {
        this.tips_address_model = !this.tips_address_model;
        return false;
      }
      //判断一票一证时  观演人是否为空
      if (
        this.$refs.ticketViewer &&
        this.$refs.ticketViewer.cardTableData.length < 1 &&
        this.real_name_type == 2
      ) {
        this.tips_model = !this.tips_model;
        return false;
      }
      //判断观演人与取票数量是否一致
      if (
        this.$refs.ticketViewer &&
        this.$refs.ticketViewer.cardTableData.length !=
          this.$refs.ticketViewer.mul_totalCount &&
        this.real_name_type == 2
      ) {
        this.publicMethod.getThrowInfo(
          "添加观演人人数信息与购票数量不一致!",
          "error"
        );
      } else {
        this.dialogFormVisible = true;
      }
    },
    //确认提交订单判定form中的身份证表单校验
    checkFormCard(flag) {
      if (flag.check_flag) {
        this.cardForm_kuaidi.ownerIdCardNo = flag.card;
        this.checkTicketInfo();
      }
    },
    //确认提交订单判定form表单校验
    checkFromData(flag) {
      if (flag.check_flag) {
        //赋值提交时的取票人信息
        this.cardForm_ticket.consigneeName = flag.name;
        this.cardForm_ticket.consigneePhone = flag.phone;
        this.cardForm_ticket.ownerIdCardNo = flag.card;
        //判断验证码是否正确
        let confirmSource = {
          consigneePhone: flag.phone,
          verificationCode: flag.code,
        };
        let code_flag = false;
        this.apis.showOrder
          .getConfirmCode(confirmSource)
          .then((res) => {
            code_flag = !res ? false : !res.code;
          })
          .then(() => {
            if (code_flag) {
              this.checkTicketInfo();
            } else {
              //this.publicMethod.getThrowInfo("验证码填写有误!", "error");
            }
          });
      }
    },
    //返回详情页面
    backToDetail() {
      this.$router.push({
        path: "/detail",
        query: { id: this.currentGoodsId },
      });
    },
  },
};
</script>

<style scoped lang="less">
.dialog_btn {
  .drama_specs_unit(120px, 40px);
  border-radius: 4px;
  font-size: 14px;
}
/deep/ .dialog_confirm {
  font-weight: bold !important;
  color: rgba(255, 255, 255, 1);
  background: linear-gradient(
    315deg,
    rgba(92, 180, 236, 1) 0%,
    rgba(61, 150, 226, 1) 100%
  );
  margin-right: 20px;
}
.dialog_cancel {
  border: 1px solid #e5e5e5;
  color: #666;
  background: #fff;
  &:hover {
    border: 1px solid #e5e5e5;
    color: #666;
    background: #fff;
  }
}
.confirm_top {
  text-align: center;
  img {
    width: 68px;
    display: inline-block;
    vertical-align: middle;
  }
  .confirm_text {
    .drama_font_style(inherit, 400, 18px, 25px);
    margin: 18px auto 36px;
    color: rgba(51, 51, 51, 1);
  }
  .confirm_text_error {
    margin-top: 16px !important;
  }
}
/deep/ .el-dialog {
  .drama_position_attr(absolute, 50%, auto, auto, 50%);
  transform: translate(-50%, -50%);
  margin: 0 !important;
}
/deep/ .el-dialog__header {
  font-size: 18px;
  color: rgba(17, 17, 17, 1);
  line-height: 24px;
  padding: 16px 20px;
  position: relative;
}
/deep/ .el-dialog__header::after {
  .drama_position_attr(absolute, auto, auto, 0, 0);
  content: "";
  display: block;
  height: 1px;
  width: 528px;
  background: rgba(229, 229, 229, 1);
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.05);
}
/deep/ .confirm_dialog .el-dialog__header::after {
  height: 0;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
/deep/ .el-dialog__body {
  padding: 0px 61px 4px;
}
/deep/ .confirm_dialog_body .el-dialog__body {
  padding: 0px 19px 4px;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding: 0;
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 32px;
}
/deep/ .el-dialog__body {
  .el-input {
    width: 350px;
    height: 32px;
    .el-input__inner {
      .drama_wrap_attr(100%, 100%, 32px, 12px, rgba(17, 17, 17, 1), inherit);
      padding: 0 12px;
    }
  }
  .ticket_dialog_form {
    .el-form-item__label {
      font-size: 14px;
    }
    .el-input__inner {
      font-size: 14px;
    }
  }
}
/deep/ .el-form-item {
  margin: 28px 0;
}
/deep/ .el_first_item {
  margin-top: 16px;
}
/deep/ .el_first_item .el-form-item__label {
  letter-spacing: 12px;
}
/deep/ .el_first_itemEn .el-form-item__label {
  letter-spacing: 0px;
}
/deep/ .el-form-item__content {
  line-height: 32px;
}
/deep/ .el-form-item__contentEN {
  line-height: 32px;
}
/deep/ .el-dialog__footer {
  padding: 0 20px 40px;
}
/deep/ .confirm_dialog_body .el-dialog__footer {
  padding: 8px 20px 24px;
}
.error_footer {
  margin-bottom: 3px;
}
/deep/ .error_footer .dialog_confirm {
  margin-right: 0;
}

.ticket_info,
.order_info,
.total_info {
  border: 1px solid rgba(229, 229, 229, 1);
  margin-top: 24px;
  margin-bottom: 30px;
  box-sizing: border-box;
}
.total_info::after {
  content: "";
  display: block;
  visibility: hidden;
  height: 0;
  clear: both;
}
.border_br {
  width: 100%;
  height: 1px;
  background: rgba(247, 247, 247, 1);
}
.ticket_info {
  padding: 0 24px;

  .ticket_icon {
    line-height: 21px;
  }
  .ticket_icon img {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }
  .ticket_icon span {
    .drama_font_style(inherit, 500, 16px, 21px);
    display: inline-block;
    margin-left: 15px;
    color: rgba(17, 17, 17, 1);
    height: 21px;
  }
  .ticket_icon i {
    .drama_font_style(normal, 500, 12px, 16px);
    margin-left: 4px;
    color: rgba(102, 102, 102, 1);
  }

  .ticket_info_location_more {
    cursor: pointer;
    span {
      display: inline-block;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
    }
    img {
      width: 12px;
      height: 12px;
      margin-bottom: 2px;
      margin-left: 8px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .locaton_more_checked {
    span {
      color: rgba(61, 150, 226, 1);
    }
  }

  .ticket_info_user {
    padding-top: 26px;
    box-sizing: border-box;
  }
}
.total_info {
  padding: 33px 24px 0 0;
  .total_info_right {
    float: right;
    text-align: right;
    font-size: 12px;
    .total_info_right_title {
      align-items: center;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
      display: flex;
      justify-content: flex-end;
      .new_total_style {
        width: 99px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .right_title_text {
        color: rgba(102, 102, 102, 1);
        line-height: 16px;
      }
      img {
        width: 15px;
        height: 15px;
        margin: 0 2px 0 8px;
      }
    }
    .total_info_right_pay {
      .drama_font_style(inherit, bold, 20px, 24px);
      color: rgba(244, 69, 69, 1);
    }
    .serviceFeeTip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff6600;
      line-height: 20px;
      margin-top: 10px;
    }
    .total_info_right_btn {
      a {
        .drama_font_style(inherit, bold, 16px, 52px);
        width: 160px;
        height: 52px;
        margin: 12px 0;
        display: inline-block;
        text-align: center;
        background: linear-gradient(
          315deg,
          rgba(92, 180, 236, 1) 0%,
          rgba(61, 150, 226, 1) 100%
        );
        border-radius: 4px;
        color: rgba(255, 255, 255, 1);
      }
    }
    .total_info_right_tips {
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
      line-height: 17px;
      margin-bottom: 28px;
    }
  }
}
.confirm_user_list {
  padding-top: 16px;
  width: 364px;
  text-align: center;
  margin: 16px 63px 20px 63px;
  .ticket_info_user_onlyitem {
    margin-bottom: 20px !important;
  }
}
.confirm_title {
  .drama_font_style(inherit, bold, 20px, 26px);
  margin: 24px 0 25px 0;
  color: rgba(51, 51, 51, 1);
}
.order_info_title {
  padding: 0 24px;
}

.order-wrap {
  width: 1200px;
  margin: 0 auto;
}

/deep/ .el-form-item__error {
  padding-left: 15px;
}
/deep/ .el-form-item__error::before {
  width: 12px;
  height: 12px;
  content: "";
  display: block;
  .drama_position_attr(absolute, 5px, auto, auto, 0);
  background: url("../../assets/imgs/input_error.png") no-repeat;
  background-size: 100% 100%;
}
.not_allowed_btn {
  cursor: not-allowed !important;
  background: #ececec !important;
}
.active_background {
  background: #f4f9fe !important;
}
/deep/ .el-form-item.is-error .el-input__inner {
  border-color: #e5e5e5;
}
.top_steps {
  display: flex;
  margin: 16px 0;
  .click_point {
    cursor: pointer;
  }
  span {
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    line-height: 16px;
    display: inline-block;
  }
  .product_name {
    width: 252px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .top_arrow_icon img {
    width: 12px;
    height: 12px;
    margin: 2px 4px;
  }
}
</style>
<style lang="less">
* {
  margin: 0;
  padding: 0;
  font-weight: 500;
}
* .dialog_confirm {
  span {
    font-weight: bold !important;
    display: inline-block;
  }
}
/deep/ .dialog_confirm {
  font-weight: bold !important;
  span {
    font-weight: bold !important;
    display: inline-block;
  }
}

.header-title .title-del {
  width: 28px;
  height: 28px;
  background: #ffffff;
  .drama_position_attr(absolute, 14px, 14px, auto, auto);
  z-index: 99;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
  }
}
.header-title .title_confirm_del {
  top: 11px;
  right: 11px;
}

[v-cloak] {
  display: none;
}
</style>
